module.exports = __webpack_public_path__ + "img/9.d028a6c0.jpg";